import { createSelector } from "reselect";
const selector = (state) => state.salesAdjustment;

export default createSelector([selector], (data) => data);